/** Métricas compartidas para pentagramas en pantalla e impresión (~10–11 px entre líneas). */

export const VEX_PRINT = {
  /** Altura visible objetivo del SVG en impresión (px). */
  svgHeight: 108,
  canvasHeight: 148,
  staveY: 38,
  noteColor: '#0a0a0a',
  openHeadFill: '#ffffff',
  stemWidth: 1.35,
  openHeadStroke: 1.85,
  barlineWidth: 1.35,
  /** Margen inferior extra cuando hay sílabas Takadimi bajo el pentagrama. */
  labelBottomPad: 36,
} as const;

export const VEX_SCREEN = {
  svgHeight: 160,
  canvasHeight: 168,
  staveY: 44,
  labelBottomPad: 42,
} as const;
